module.exports = __webpack_public_path__ + "img/add-box-line.4cd24fc0.svg";